import QueryString from "qs";

import axios from "@src/api/axios";
import { BASE_URL } from "@src/utils";

import * as Types from "@src/types/community";

// community
export interface ICommunityListItem {
  anonymousText: string | null;
  answer: null | {
    authorNick: string;
    content: string;
    regTsp: string;
  };
  block: number;
  blockV2: number;
  card:
    | {
        content: string;
        coverUrl: string;
        isCard: number;
        link: string;
        partnerType: number;
        partnerUuid: string;
        title: string;
        type: number;
        wegazineUuid: string | null;
      }
    | {
        content: string;
        coverUrl: string;
        isCard: number;
        link: string;
        partnerType: number;
        partnerUuid: string;
        title: string;
        type: number;
        wegazineUuid: string | null;
      }[]
    | null; //확인된 데이터 형식에 따라 형식 추가(null, 단일 객체) 240731 / 배열 형태는 확인이 안되었으나 기존 작성된 형태여서 유지
  content: string;
  customerUuid: string;
  id: number;
  images: { url: string }[];
  isAnonymous: number;
  isCertification: number;
  isLike: number;
  likeCnt: number;
  // messagecards: null
  myCustomerPartnerId: number;
  nick: string;
  partnerText: string;
  platformReviewId: number;
  productNo: number | null;
  profileUrl: string;
  regTsp: string;
  region: string;
  replyCnt: number;
  reviews: {
    g: number;
    k: string;
    kname: string;
    v: string;
  }[];
  state: number;
  tags: { id: number; name: string }[];
  type: number;
  uuid: string;
  weddingMonth: string;
}

export interface ICommunityCommentListItem {
  id: number;
  depth: number; // 댓글 1, 대댓글 2
  uuid: string;
  rootUuid: string;
  upperId: number | null;
  upperUuid: string | null;
  upperNick: string | null;
  content: string;
  customerUuid: string;
  secretAllow: number;
  mentorState: number;
  nick: string;
  secret: number;
  anonymous: number;
  profileUrl: string;
  weddingMonth: string;
  partnerText: string | null;
  anonymousText: string | null;
  isLike: number;
  likeCnt: number;
  dday: number | null;
  block: number;
  certification: number;
  isReview: number;
  state: number;
  regTsp: string;
  images: { url: string }[];
  tags: { id: number; name: string }[];
  blockV2: number;
}

export interface IBlogListItem {
  id: number;
  partnerId: number;
  originUrl: string;
  nick: string;
  profileUrl: string;
  regTsp: string;
  title: string;
  content: string;
  images: { url: string }[];
}

interface IReportParam {
  category: 1 | 2 | 3;
  uuid: string;
  content: string;
}

interface IBlockParam {
  myUuid: string;
  targetUuid: string;
}

// 커뮤니티 리뷰 호출
export const getCommunityList = (params: any = {}) => {
  const p = new URLSearchParams(params).toString();
  return axios.get<{ item: ICommunityListItem[] }>(
    `${BASE_URL}/web/v3/230531/community?category=4&${p}`,
  );
};

// 블로그 리뷰 호출
export const getBlogList = (params, partnerUuid) => {
  const p = new URLSearchParams(params).toString();
  return axios.get<{ item: any; total: any; result: any }>(
    `${BASE_URL}/web/v3/240722/partners/${partnerUuid}/blog-reviews?${p}`,
  );
};

// 리뷰 상세 호출
export const getReviewDetail = (params, communityUuid) => {
  const p = new URLSearchParams(params).toString();
  return axios.get<{ item: any; total: any; result: any }>(
    `${BASE_URL}/web/v1/communityV2/${communityUuid}?${p}`,
  );
};

// 리뷰 삭제
export const deleteReview = (communityUuid) => {
  // const accessToken = localStorage.getItem("accessToken");
  // const headers = {
  //   Authorization: `bearer ${accessToken}`,
  // };
  return axios.delete(`${BASE_URL}/web/v3/20240810/community/${communityUuid}?type=2`);
};

// 코멘트 리스트 호출
export const getCommunityCommentList = (params) => {
  const p = new URLSearchParams(params).toString();
  return axios.get<{ item: ICommunityCommentListItem[] }>(
    `${BASE_URL}/web/v1/reply?category=2&${p}`,
  );
};

// 코멘트 신규 작성
export const submitCommunityComment = (params) => {
  const p = new URLSearchParams(params).toString();
  return axios.post<{ item: ICommunityCommentListItem }>(
    `${BASE_URL}/web/v1/reply?category=2&${p}`,
  );
};

// 코멘트 수정
export const updateCommunityComment = (communityUuid, params) => {
  const p = new URLSearchParams(params).toString();
  return axios.put<{ item: ICommunityCommentListItem }>(
    `${BASE_URL}/web/v1/reply/${communityUuid}?category=2&${p}`,
  );
};

// 코멘트 삭제
export const deleteCommunityComment = (communityUuid, param) => {
  const p = new URLSearchParams(param).toString();
  return axios.delete<{ item: ICommunityCommentListItem }>(
    `${BASE_URL}/web/v1/reply/${communityUuid}?category=2&${p}`,
  );
};

// 리뷰, 코멘트 신고
export const reportCommunity = ({ category, uuid, content }: IReportParam) => {
  const categoryToString = category.toString();
  const param = {
    category: categoryToString,
    content: content,
  };
  const p = new URLSearchParams(param).toString();
  return axios.post(`${BASE_URL}/web/v3/230531/community/${uuid}/black?${p}`, {
    category: category,
    content: content,
  });
};

// 리뷰, 코멘트 차단
export const blockCommunity = ({ myUuid, targetUuid }: IBlockParam) => {
  const param = {
    customerUuid: myUuid,
    banCustomerUuid: targetUuid,
  };
  const p = new URLSearchParams(param).toString();
  return axios.post(`${BASE_URL}/web/v3/230531/community/ban?${p}`, {
    customerUuid: myUuid,
    banCustomerUuid: targetUuid,
  });
};

// 리뷰 좋아요
export const likeReview = (communityUuid: string, state: number, customerUuid: string) => {
  //type(1:좋아요 / 2:도움돼요 / 3:예뻐요 / 4:공감해요 / 5:힘내요) --> 좋아요 단일로 변경으로 1만 사용
  //state (1: 등록 / 0: 취소)
  // 리뷰 좋아요 카테고리 2, 코멘트 좋아요 카테고리 3
  return axios.post(
    `${BASE_URL}/web/v3/230531/community/${communityUuid}/like`,
    QueryString.stringify({
      category: 2,
      type: 1,
      state: state,
    }),
  );
};

// 코멘트 좋아요
export const likeComment = (communityUuid: string, state: number, customerUuid: string) => {
  return axios.post(
    `${BASE_URL}/web/v1/community/${communityUuid}/like`,
    QueryString.stringify({
      category: 3,
      type: 1,
      state: state,
      uuid: customerUuid,
    }),
  );
};

// 익명 닉네임 생성 - 익명 댓글 작성 시 해당 값으로 파라미터
export const getAnonymousNick = (myUuid) => {
  //{"item":{"nick":"익명2f92","isAnonymous":0},"result":null,"total":null}
  return axios.get<{ item: { nick: string; isAnonymous: number } }>(
    `${BASE_URL}/v1/anonymous?uuid=${myUuid}`,
  );
};

// 공식 이미지 호출
export const getOfficialPhoto = (params, partnerUuid) => {
  const p = new URLSearchParams(params).toString();
  return axios.get<{
    total: number;
    item: {
      url: string;
      title: string | null;
      content: string | null;
      albumId: number | null;
    }[];
  }>(`${BASE_URL}/v1/partner/${partnerUuid}/image?category=1&${p}`);
};

// 리뷰 이미지 호출
export const getReviewPhoto = (params, partnerUuid) => {
  const p = new URLSearchParams(params).toString();
  return axios.get<{
    total: number;
    item: {
      url: string;
      title: string | null;
      content: string | null;
      albumId: number | null;
    }[];
  }>(`${BASE_URL}/v1/partner/${partnerUuid}/image?category=2&${p}`);
};

// 폴더 이미지 호출
export const getFolderPhoto = (params) => {
  const p = new URLSearchParams(params).toString();
  return axios.get<{
    total: number;
    item: {
      url: string;
      width: number;
      height: number;
    }[];
  }>(`${BASE_URL}/v1/albumPhoto?${p}`);
};

// 블로그 리뷰 작성
export const postBlogReview = (param, partnerUuid, blogUrl) => {
  const p = new URLSearchParams(param).toString();
  const accessToken = localStorage.getItem("accessToken");
  const headers = {
    Authorization: `bearer ${accessToken}`,
  };

  return axios.post<{ result: { result: string } }>(
    `${BASE_URL}/web/v3/240722/partners/${partnerUuid}/blog-reviews?${p}`,
    {
      blogUrl: blogUrl,
    },
    {
      headers,
    },
  );
};

// 블로그 리뷰 삭제
export const deleteBlogReview = async (blogReviewUuid: string) => {
  return axios.delete(`${BASE_URL}/web/v3/20241111/partners/blog-reviews/${blogReviewUuid}`);
};

// 내가 리뷰 작성 가능한 업체 리스트 호출
export const getMyWriteableReviewPartnerList = async (fetchStart: number, fetchSize: number) => {
  const res = await axios.get<{
    item: Types.IResMyWriteableReviewPartner[];
    total: number;
    nextFetchStart: number;
  }>(
    `${BASE_URL}/web/v3/20241111/community/reviewable?fetchStart=${fetchStart}&fetchSize=${fetchSize}`,
  );
  return {
    item: res.data.item,
    total: res.data.total,
    nextFetchStart: fetchStart + fetchSize,
  };
};

// 내가 작성한 리뷰 업체 리스트 호출
export const getMyWrittenReviewPartnerList = async (fetchStart: number, fetchSize: number) => {
  const res = await axios.get<{
    item: Types.IResMyWrittenReviewPartner[];
    total: number;
    nextFetchStart: number;
  }>(
    `${BASE_URL}/web/v3/20241111/community/written-reviews?fetchStart=${fetchStart}&fetchSize=${fetchSize}`,
  );
  return {
    item: res.data.item,
    total: res.data.total,
    nextFetchStart: fetchStart + fetchSize,
  };
};
